export default __webpack_public_path__ + "static/media/image5.9617a611.png";